import { makeAutoObservable } from 'mobx';
import _ from 'lodash';

class RoleAssignmentViewModel {
  user;
  role;
  checked;

  constructor(user, role) {
    makeAutoObservable(this);

    this.user = user;
    this.role = role;
    this.checked = !!this.findExistingAssignment();
  }

  findExistingAssignment() {
    return _.find(
      this.user.roleAssignments,
      assignment => assignment.role.id === this.role.id
    );
  }

  toJS() {
    const existingAssignment = this.findExistingAssignment();
    return {
      id: _.get(existingAssignment, 'id'),
      role_id: this.role.id
    };
  }
}

export default RoleAssignmentViewModel;
